<div class="spaced-top" [hidden]="hidden">
    <ngx-datatable class="material"
                   (activate)="onActivate($event)"
                   (page)="pageChanged($event)"
                   (sort)="sortChanged($event)"
                   [externalSorting]="true"
                   [rows]="rows"
                   [footerHeight]="25"
                   [count]="page.count"
                   [limit]="page.limit"
                   [offset]="page.offset"
                   [externalPaging]="true">
            <ngx-datatable-column *ngFor="let header of headers; let i = index" name="{{header}}" width="{{width[i]}}">
                <ng-template let-row="row" let-value="value" ngx-datatable-cell-template>
                    <mat-icon *ngIf="showDeactiveIcon && i === 1 && checkDeactivated(row)" matTooltip="Disabled" class="deactivated-icon">remove_circle_outline</mat-icon>
                    {{ value }}
                </ng-template>
            </ngx-datatable-column>
    </ngx-datatable>
</div>
<div *ngIf="filterToggle" class="toggle-format spaced-top">
    <mat-slide-toggle (change)="filterChanged()" [(ngModel)]="filter" class="toggle" color="primary" name="toggleFilter"></mat-slide-toggle>
    <label class="padded-left">{{ filterDesc }}</label>
</div>
